import { CaretRightIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import * as Styles from './styles'

const OrderRowIcon = ({ loading }) => {
  const theme = useTheme()

  if (loading) {
    return <Styles.Spinner data-testid="spinner" size={20} weight="light" color={theme.colors.grey.tone700} />
  }

  return <CaretRightIcon size={20} color={theme.colors.grey.tone700} />
}

export default OrderRowIcon
